import React, { Component } from 'react';
import { getBaseName, nl2br } from '../common/Utils';
import { withTranslation, useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import moment from 'moment';

class NewsNotification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: null,
            errors: null
        };
    }

    async loadData() {

        const apiParams = new URLSearchParams({
            refNo: this.props.refNo
        });
        const apiUrl = `${getBaseName()}/api/news/notification?${apiParams.toString()}`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {            
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                console.log(result);

                this.setState({
                    news: result
                });
            } else {
                this.props.history.push(`/gateway/EN/error`);     
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentDidMount() {
        this.loadData();

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }

    }

    render() {        
        const { news } = this.state;

        if (news) {
            return (
                <div>
                    <Helmet>
                        <title dangerouslySetInnerHTML={{__html:news.enTitle + " " + news.tcTitle}}></title>	
                    </Helmet>
                    <NewsContent
                        lang="EN"
                        hasContent={true}
                        title={news.enTitle}
                        html={news.enHtml} 
                        news={news}/>

                    <br/><hr/><br/>
                    <NewsContent
                        lang="TC"
                        hasContent={true}
                        title={news.tcTitle}
                        html={news.tcHtml} 
                        news={news}/>
                </div>
            );
        } else {
            return (<div>Loading...</div>)
        }
    }
}

function NewsContent(props) {
    const { t } = useTranslation();
    const { lang, hasContent, title, html, news } = props;

    if (!hasContent) {
        return (<br/>);
    } else {
        return (
            <div>
                <h3 style={{
                    "textAlign": "center", 
                    "fontSize": "14px", 
                    "fontFamily": "Calibri Light"
                }}>
                    <strong>
                        {title}<br/>
                        {t('common:date.formatter',{lng:lang,date: moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                    </strong>
                </h3>
                <p style={{
                    "textAlign": "center", 
                    "fontSize": "12px", 
                    "fontFamily": "Calibri Light"
                }} dangerouslySetInnerHTML={{ __html: nl2br(html)}}/>
                {news.imageList.filter((image) => lang === image.lang).map((image) => 
                    <div key={image.imageRefNo} className="newsImageWrapper">
                        <img className="newsImage" src={`${process.env['PUBLIC_URL']}/api/news/openImage?refNo=${news.newsRefNo}&lang=${lang}&image=${image.imageRefNo}`}>
                        </img>
                            <p>{image.caption}</p>
                        <br/>
                    </div>
                )}
                {news.appendixDocList.filter((appendix) => lang === appendix.lang).map((appendix) =>
                    <Link key={appendix.refNo} to={`openAppendix?refNo=${news.newsRefNo}&appendix=${appendix.refNo}`} target="_blank">
                        <br/>
                        {appendix.caption}
                    </Link>
                )}
            </div>
        );
    }


}

export default withTranslation()(NewsNotification);